import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ERROR } from '@co-assist/library';

enum CustomErrorMessages {
    LOGIN_BLOCKED,
    REMAINING_ATTEMPT
}
@Injectable({
    providedIn: 'root'
})
export class ErrorMatcher {
    logError: Array<{ message: string, arg?: any }> = [];
    private missingVerification: boolean = false;
    private showRenewPasswordLink: boolean = false;
    private error400: string = '[400] Bad Request: ';

    constructor() { }

    get errorMessages() { return CustomErrorMessages; }

    isError(): boolean {
        return this.logError.length > 0;
    }
    isMissingVerification(): boolean {
        return this.missingVerification;
    }
    get getShowRenewPasswordLink(): boolean {
        return this.showRenewPasswordLink;
    }

    shouldCheckConnectionsAttempts(err: HttpErrorResponse): boolean {
        switch (this.clearPrefix(err.error.errorMessage)) {
            case ERROR.ERROR_MESSAGES.TOO_OLD_PASSWORD:
            case ERROR.ERROR_MESSAGES.OTP_NO_AVAILABLE_CHANNEL:
                return false;
        }
        return true;
    }

    setError(err: HttpErrorResponse, arg?: any): string {
        this.clear();
        const cleanErrorMessage: string = this.clearPrefix(err.error.errorMessage);
        this.showRenewPasswordLink = false;

        switch (cleanErrorMessage) {
            case ERROR.ERROR_MESSAGES.WRONG_EMAIL:
                this.logError.push({ message: 'VALIDATION.WRONG_EMAIL' });
                break;
            case ERROR.ERROR_MESSAGES.NON_EXISTENT_USER:
                this.logError.push({ message: 'VALIDATION.NON_EXISTENT_USER' });
                break;
            case ERROR.ERROR_MESSAGES.WRONG_PHONE_NUMBER:
                this.logError.push({ message: 'VALIDATION.WRONG_TEL' });
                break;
            case ERROR.ERROR_MESSAGES.MISSING_VERIFICATION:
                this.missingVerification = true;
                this.logError.push({ message: 'LOGIN.MISSING_VERIFICATION' });
                break;
            case ERROR.ERROR_MESSAGES.OTP_MUST_BE_SUPPLIED:
                this.logError.push({ message: 'LOGIN.OTP_MUST_BE_SUPPLIED' });
                break;
            case ERROR.ERROR_MESSAGES.OTP_INCORRECT:
                this.logError.push({ message: 'LOGIN.OTP_ERROR' });
                break;
            case ERROR.ERROR_MESSAGES.OTP_NO_AVAILABLE_CHANNEL:
                this.logError.push({ message: 'LOGIN.OTP_NO_AVAILABLE_CHANNEL' });
                break;
            case ERROR.ERROR_MESSAGES.TOO_OLD_PASSWORD:
                this.showRenewPasswordLink = true;
                this.logError.push({ message: 'LOGIN.PASSWORD_TOO_OLD' });
                break;
            case ERROR.ERROR_MESSAGES.WRONG_VALIDATION_CODE:
                this.logError.push({ message: 'VALIDATION.VALIDATION_CODE_ERROR' });
                break;
            case ERROR.ERROR_MESSAGES.NO_EXISTING_EMAIL:
                this.logError.push({ message: 'PASSWORD_RESET.EMAIL_ERROR' });
                break;
            case ERROR.ERROR_MESSAGES.WRONG_UPDATE_LINK:
                this.logError.push({ message: 'PASSWORD_RESET.WRONG_LINK_TITLE' });
                break;
            case ERROR.ERROR_MESSAGES.LINK_EXPIRED:
                this.logError.push({ message: 'PASSWORD_RESET.OLD_LINK_TITLE' });
                break;
            case ERROR.ERROR_MESSAGES.NEW_PASSWORD_NEEDED:
                this.logError.push({ message: 'PASSWORD_RESET.DIFFERENT_PASSWORD_NEEDED' });
                break;
            case ERROR.ERROR_MESSAGES.BAD_LOGIN:
                this.logError.push({ message: 'LOGIN.LOGIN_FAILURE' });
        }
        return cleanErrorMessage;
    }
    setCustomError(err: CustomErrorMessages, arg: any) {
        switch (err) {
            case CustomErrorMessages.LOGIN_BLOCKED:
                this.clear();
                this.logError.push({ message: 'LOGIN.LOGIN_BLOCKED', arg });
                break;
            case CustomErrorMessages.REMAINING_ATTEMPT:
                this.logError.push({ message: arg === 1 ? 'LOGIN.REMAINING_ATTEMPT' : 'LOGIN.REMAINING_ATTEMPTS', arg });
        }
    }
    clear(): void {
        this.logError = [];
        this.missingVerification = false;
    }

    private clearPrefix(errorMessage: string, prefix: string = this.error400) {
        return (errorMessage?.startsWith(prefix)) ? errorMessage.split(prefix)[1] : errorMessage;
    }
}
